module.exports = __webpack_public_path__ + "static/media/four-people.e4d21f6e.png";